<template>
	<div>
		<compWrapper :title="$t('erp.managewarehouse.shipping_method_map', { defaultValue: '仓库发运方式映射' })" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getWarehouse" :value="formData" :labelWidth="235"></compFormQuery>
			<compFormEdit
				v-else
				class="margin-top-15 clearfix"
				ref="editform"
				:formdata="getWarehouse"
				v-model="formData"
				:labelWidth="235"
			/>
			<div class="text-right padding-right-20" v-show="type!='query'">
				<vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
				<vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
			</div>
		</compWrapper>
		<compWrapper :title="$t('global.common.operation_history', { defaultValue: '操作历史' })" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList"></compLog>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { HttpCreateWarehouse, HttpDetailWarehouse, HttpEditWarehouse, HttpAllLogs } from "@/service/managechannel/managechannel";
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		carrierSystem: () => import("../publictable/carrierSystemTable.vue"),
		compLog: () => import("./log"),
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			channelAccountList: [],
			opLogList: [],
			formData: {
				channelType: '',
				channelAccount: "",
			},
			products: [],
			loading: false,
		}
	},
	created() {
		this.query = this.type === "query";
		if (this.type == 'query' || this.type == 'edit') {
			this.getDetail()
		}
		// this.HttpGetContry()
	},
	computed: {
		...mapState('boss', ['orgwarehouses', 'sysdeliveries', 'syscarrier', 'sysservice', 'accountTypes']),
		...mapGetters('diction',['getNewAccountList']),
        getNoAmazonware(){
            return this.orgwarehouses.filter(item => {
                return item.warehouseType !== 2
            });
        },
		// newAccountList
		getWarehouse() {
			let showquery = this.type == 'edit' || this.type == 'query'
			let showtrue = this.type != 'edit' && this.type != 'query'
			let arrayList = [], channelTypeList;
			this.channelAccountList = [];
			let array = this.formData.channelType.split('&')
			this.getNewAccountList.map(item => {
				// console.log(item)
				if (item.attach.siteName == array[0]) {
					this.channelAccountList.push(item)
				}
			})

			return [
				{
					label: this.$t('erp.managewarehouse.shop_type', { defaultValue: "店铺类型" }),
					key: "channelType",
					tag: "vSelect",
					span: 24,
					required: false,
					query: showquery,
					formItem: {
						style: "width:50%"
					},
					options: this.accountTypes.map(function (item) {
						// console.log(item)
						return {
							value: item.name + '&' + item.id,
							label: item.name
						}
					}),
					props: {
						filterable: true,
					}
				},
				{
					label: this.$t('erp.managewarehouse.shop_name', { defaultValue: "店铺名称" }),
					tag: "vSelect",
					span: 24,
					key: "channelAccount",
					required: false,
					query: showquery,
					formItem: {
						style: "width:50%"
					},
					options: this.channelAccountList,
					props: {
						filterable: true,
					}
				},
				
                {
					label: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
					// key: "warehouseTitle",
					span: 24,
					valueText: this.formData.warehouseTitle + "(" + this.formData.warehouseCode + ")",
					query: showquery,
					show: this.type == 'query' || this.type == 'edit',
					formItem: {
						style: "width:50%"
					},
				},
                {
					label: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
					key: "warehouseId",
					span: 24,
					tag: 'vSelect',
					options: this.getNoAmazonware.map(function (item) {
						const { id, title, code } = item;
						return {
							value: id,
							label: title + '(' + code + ')'
						}
					}),
					show: this.type == 'addnewpage',
					formItem: {
						style: "width:50%"
					},
					props: {
						filterable: true,
					},
                    on:{
                        'on-change':()=>{
                            this.$set(this.formData, 'carrierServiceCode', '')
							this.$set(this.formData, 'carrierServiceApiCode', '')
                        }
                    }
				},
                {
					label: this.$t('fbb.alloment.carrier_server', { defaultValue: "物流产品服务" }),
					key: "code",
					span: 12,
					show: this.type!='addnewpage',
					query: showquery,
				},
				{
					label: this.$t('fbb.alloment.carrier_server', { defaultValue: "物流产品服务" }),
					key: "carrierServiceCode",
					span: 24,
					show: this.type=='addnewpage',
					props: {
						readonly: true
					},
					children: (h) => {
						return <vIcon
							type="search"
							center
							slot="suffix"
							style="padding:6px;padding-right:20px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalsystem.bind(this)}
						/>
					},
					formItem: {
						style: "width:50%",
					},
                    popper:this.$t('erp.channelbase.logcarrier_popper', { defaultValue: '物流产品服务' }),
				},
				
				
				// {
				// 	label: this.$t('fbb.warehousecarrierservice.query', { defaultValue: "系统仓库发运方式" }),
				// 	key: "carrierServiceApiCode",
				// 	span: 24,
				// 	// show:showquery,
				// 	query: this.type == 'query',
				// 	formItem: {
				// 		style: "width:50%",
				// 	},
                //     popper:this.$t('erp.channelbase.carrierapi_popper', { defaultValue: '系统仓库发运方式' }),
                //     required:false,
				// },
				{
					label: this.$t('erp.managewarehouse.third_party_print_order_account', { defaultValue: "三方打单账号" }),
					key: "carrierAccount",
					// show:this.formData.channelAccount!='',
					span: 24,
					required: false,
					formItem: {
						style: "width:50%",
						tip: this.type == 'edit' || this.type == 'query' ? '' : `<div class="color-error">${this.$t('erp.managewarehouse.third_party_tips', { defaultValue: '如果选择三方打单账号，则必须指定店铺类型和店铺名称' })}</div>`
					},
				},
			];
		},
	},
	methods: {
		handleModalsystem() {
            if(!this.formData.warehouseId){
                this.$VMessage.error(this.$t('global.common.choose', { defaultValue: "请选择" })+' '+this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }));
                return;
            }
			this.$VModal.info({
				title: this.$t('fbb.alloment.carrier_server', { defaultValue: "物流产品服务" }),
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement("carrierSystem", {
						props: {
							// 'sysdeliveries','syscarrier','sysservice'
							warehouseId: this.formData.warehouseId,
						},
						on: {
							rows: (rows) => {
								// console.log(rows)
								this.$set(this.formData, 'carrierServiceCode', rows.code)
								this.$set(this.formData, 'carrierServiceApiCode', rows.code)
								this.$VModal.destroy();
							},
							cancel: () => {
								this.$VModal.destroy();
							}
						}
					})
				}
			})
		},
		getDetail() {
			this.loading = true;
			HttpDetailWarehouse({
				id: this.id
			}).then(
				res => {
					this.handleResponse(res.data);
				},
				err => {
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			).finally(res => {
				this.loading = false
			})
			// 请求日志的接口
			HttpAllLogs({
				search: {
					EQ_opData: this.id,
					EQ_opModel: 'OrgWarehouseCarrierService'
				}
			}).then(res => {
				this.opLogList = res.data
			}, err => {

			})
		},
		handleResponse(data = {}) {
			this.formData = data
		},
		async submit() {
			let bool = await this.$refs.editform.validate()
			if (!bool) return

			let array = this.formData.channelType.split('&')
			this.formData.channelType = array[0]
			if (this.type == 'edit') {
				HttpEditWarehouse({
					id: this.id,
					...this.formData
				}).then(res => {
					this.$VMessage.success(res.message);
					this.$router.push({
						name: 'managewarehouse',
					});
				}, err => {
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				})
			} else {
				HttpCreateWarehouse({
					...this.formData,
				}).then(res => {
					this.$VMessage.success(res.message);
					this.$router.push({
						name: 'managewarehouse',
					});
				}, err => {
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				})
			}
		},
		cancel() {
			this.$router.push({
				name: 'managewarehouse',
			});
		}
	},
}
</script>
